import { DIM_FONT, EColorRef, EDimOrientation, EPrimitiveKind, IBox, IDimPrimitive } from './plan-primitive';
import { ITextMeasurer } from './text-measurer';

/**
 * Dimension-primitive builders shared by every plan projection. A projection
 * emits these instead of hand-rolling its own `IDimPrimitive`; the drawer
 * rasterizes them (its `DIM_LABEL_GAP`/`VERTICAL_LABEL_OFFSET` mirror the values
 * here). `color` defaults to the neutral ink used by most dimensions; panes that
 * tint a dimension (opening / stair-width) pass an explicit colour ref.
 */

const DIM_TICK: number = 4;
const DIM_LABEL_GAP: number = 3;
const VERTICAL_LABEL_OFFSET: number = 12;

/** Horizontal dimension with end ticks and a centred label sitting above the line. */
export function horizontalDim(
    x1: number,
    y: number,
    x2: number,
    label: string,
    measurer: ITextMeasurer,
    color: EColorRef = EColorRef.Ink3
): IDimPrimitive {
    const width: number = measurer.measure(label, DIM_FONT);
    const centerX: number = (x1 + x2) / 2;
    const labelBaselineY: number = y - DIM_LABEL_GAP;
    const labelBox: IBox = [centerX - width / 2, labelBaselineY - DIM_FONT.size, centerX + width / 2, labelBaselineY];
    return {
        kind: EPrimitiveKind.Dim,
        orientation: EDimOrientation.Horizontal,
        from: [x1, y],
        to: [x2, y],
        tick: DIM_TICK,
        font: DIM_FONT,
        label,
        labelBox,
        color,
    };
}

/** Vertical dimension with end ticks and a rotated, centred label. */
export function verticalDim(
    x: number,
    y1: number,
    y2: number,
    label: string,
    measurer: ITextMeasurer,
    color: EColorRef = EColorRef.Ink3
): IDimPrimitive {
    const width: number = measurer.measure(label, DIM_FONT);
    const centerY: number = (y1 + y2) / 2;
    const labelX: number = x + VERTICAL_LABEL_OFFSET;
    const labelBox: IBox = [labelX - DIM_FONT.size, centerY - width / 2, labelX, centerY + width / 2];
    return {
        kind: EPrimitiveKind.Dim,
        orientation: EDimOrientation.Vertical,
        from: [x, y1],
        to: [x, y2],
        tick: DIM_TICK,
        font: DIM_FONT,
        label,
        labelBox,
        color,
    };
}
